import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../ui/button';

export const BackButton = ({ 
  label = 'Back', 
  to = null, 
  className = '',
  variant = 'ghost'
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (to) {
      navigate(to);
    } else {
      navigate(-1);
    }
  };

  return (
    <Button
      onClick={handleClick}
      variant={variant}
      className={`flex items-center gap-2 text-neutral-600 hover:text-neutral-900 ${className}`}
      data-testid="back-button"
    >
      <ArrowLeft className="w-4 h-4" />
      <span>{label}</span>
    </Button>
  );
};

export default BackButton;
